"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UIProvider = UIProvider;
var _theme = _interopRequireDefault(require("@a1s/theme"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _FontStack = _interopRequireDefault(require("./FontStack"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//
// Styled components
// -------------------------------------------------------------------------------------------------
const GlobalStyles = (0, _styledComponents.createGlobalStyle)`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html {
    font-size: 16px; /* ⟸ sets up the baseline to use Polish's rem helper */
    line-height: 1.5;
  }

  body {
    ${({
  background,
  theme
}) => background && (0, _styledComponents.css)`
        background-color: ${theme.ui.backgroundColor};
      `};

    color: ${p => p.theme.ui.textColor};
    font-family: ${p => p.theme.ui.baseFont};
    margin: 0;
  }
`;

//
// Main component
// -------------------------------------------------------------------------------------------------
/**
 * Sets up what's needed for rendering Marshall's UI properly. This includes: theming context,
 * custom fonts, and base styles.
 *
 * @beta
 */
function UIProvider({
  background = true,
  children
}) {
  return /*#__PURE__*/_react.default.createElement(_styledComponents.ThemeProvider, {
    theme: _theme.default
  }, /*#__PURE__*/_react.default.createElement(_FontStack.default, null), /*#__PURE__*/_react.default.createElement(GlobalStyles, {
    background: background
  }), children);
}